export const patternOrValue = (list, name, fallback) => {
    const fromVar = (Array.isArray(list) ? list : []).find((el) => el.name === name)?.pattern
    if (fromVar != null && fromVar !== "") {
        return fromVar
    }
    if (fallback == null || fallback === "") {
        return ""
    }
    return fallback
}
